if (!customElements.get('pdp-before-after')) {
  class PdpBeforeAfter extends HTMLElement {
    constructor() {
      super();
      this._dragging = false;
      this._position = 50;
    }

    connectedCallback() {
      this._track = this.querySelector('[data-track]');
      this._before = this.querySelector('[data-before]');
      this._divider = this.querySelector('[data-divider]');

      if (!this._track || !this._before || !this._divider) return;

      this._onMouseDown = this._onMouseDown.bind(this);
      this._onMouseMove = this._onMouseMove.bind(this);
      this._onMouseUp = this._onMouseUp.bind(this);
      this._onTouchStart = this._onTouchStart.bind(this);
      this._onTouchMove = this._onTouchMove.bind(this);
      this._onTouchEnd = this._onTouchEnd.bind(this);

      this._divider.addEventListener('mousedown', this._onMouseDown);
      this._divider.addEventListener('touchstart', this._onTouchStart, { passive: true });

      this._setPosition(50);
    }

    disconnectedCallback() {
      this._divider?.removeEventListener('mousedown', this._onMouseDown);
      this._divider?.removeEventListener('touchstart', this._onTouchStart);
      document.removeEventListener('mousemove', this._onMouseMove);
      document.removeEventListener('mouseup', this._onMouseUp);
      document.removeEventListener('touchmove', this._onTouchMove);
      document.removeEventListener('touchend', this._onTouchEnd);
    }

    _onMouseDown(event) {
      event.preventDefault();
      this._dragging = true;
      document.addEventListener('mousemove', this._onMouseMove);
      document.addEventListener('mouseup', this._onMouseUp);
    }

    _onMouseMove(event) {
      if (!this._dragging) return;
      this._updateFromClientX(event.clientX);
    }

    _onMouseUp() {
      this._dragging = false;
      document.removeEventListener('mousemove', this._onMouseMove);
      document.removeEventListener('mouseup', this._onMouseUp);
    }

    _onTouchStart() {
      document.addEventListener('touchmove', this._onTouchMove, { passive: false });
      document.addEventListener('touchend', this._onTouchEnd);
    }

    _onTouchMove(event) {
      event.preventDefault();
      const touch = event.touches[0];
      this._updateFromClientX(touch.clientX);
    }

    _onTouchEnd() {
      document.removeEventListener('touchmove', this._onTouchMove);
      document.removeEventListener('touchend', this._onTouchEnd);
    }

    _updateFromClientX(clientX) {
      const rect = this._track.getBoundingClientRect();
      const x = clientX - rect.left;
      const pct = Math.min(100, Math.max(0, (x / rect.width) * 100));
      this._setPosition(pct);
    }

    _setPosition(pct) {
      this._position = pct;
      this._before.style.clipPath = `inset(0 ${100 - pct}% 0 0)`;
      this._divider.style.left = `${pct}%`;
    }
  }

  customElements.define('pdp-before-after', PdpBeforeAfter);
}
